export default __webpack_public_path__ + "static/media/0xfc40a4f89b410a1b855b5e205064a38fc29f5eb5.6b41d396.webp";